var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head'),_c('Navigation'),_c('Wallpaper',{attrs:{"src":_vm.src}}),_c('Content',_vm._b({attrs:{"title":_vm.title,"items":_vm.items}},'Content',_vm.$attrs,false)),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }